export enum ENVIRONMENT {
  DEMO = 'demo',
  STAGING = 'staging',
  LOCAL = 'local',
  DEV1 = 'dev1',
  DEV2 = 'dev2',
  DEV3 = 'dev3',
  PRODUCTION = 'production',
  E2E = 'e2e',
  UNKNOWN = 'unknown',
}

export type Environment = Lowercase<keyof typeof ENVIRONMENT>;

export const isDevEnvironment = (): boolean => Boolean(!process.env.NODE_ENV || process.env.NODE_ENV === 'development');

export const getEnvironmentName = (): Environment =>
  process.env.REACT_APP_ENV_NAME ? (process.env.REACT_APP_ENV_NAME as Environment) : ENVIRONMENT.UNKNOWN;

export const getEnvironmentValue = (envName: string) => (process.env[envName] ? process.env[envName] : undefined);
